import { render, staticRenderFns } from "./CategoryImagePopover.vue?vue&type=template&id=2627c3be&"
import script from "./CategoryImagePopover.vue?vue&type=script&lang=js&"
export * from "./CategoryImagePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports